import FamilyDinner from "../../assets/family-dinning.webp";
import HappyDay from "../../assets/happy-friends.png";
import { t } from "../../translations";

const PowerHomeMadeMeal = ({ lang }) => {
  return (
    <div
      className="PowerHomeMadeMeal"
      style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
    >
      <div className="PowerHomeMadeMealContainer">
        <div className="powerOrder1">
          <h1 className="h1-power">{t("power_home_made_meal.title", lang)}</h1>
        </div>
        <div className="w-50 powerText powerOrder2">
          {
            <>
              <h1 className="h1-power h1-power-hidden">
                {t("power_home_made_meal.title", lang)}
              </h1>
              <p>
                <span style={{ fontWeight: "600" }}>
                  {t("power_home_made_meal.description_bold", lang)}
                </span>{" "}
                {t("power_home_made_meal.description_regular", lang)}
              </p>
              <p>
                {t("power_home_made_meal.call_to_action_prefix", lang)}{" "}
                <a
                  href="https://panichefs.com"
                  style={{ color: "#FF114D", fontWeight: "600" }}
                >
                  Panichefs.com
                </a>{" "}
                {t("power_home_made_meal.call_to_action_suffix", lang)}
              </p>
            </>
          }
        </div>
        <div className="w-50 dinnerPicContainer">
          <img src={FamilyDinner} alt="Family eating" />
        </div>
      </div>

      <div className="ourCommunityDivers">
        <div id="CommunityAfricans">
          <img src={HappyDay} alt="Happy Africans" />
        </div>
        <div id="OurCommuText">
          <h3 className="h3-ourStory">
            {t("power_home_made_meal.our_community", lang)}
          </h3>
          <p>
            <span style={{ fontWeight: "bold" }}>
              {t("power_home_made_meal.community_description_bold", lang)}
            </span>
            <br />
            {t("power_home_made_meal.community_description_regular", lang)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PowerHomeMadeMeal;
